import {
  List,
  StepNoticeModel,
  StepNoticeWithContentModel,
  UpdateStepNoticeModel,
} from '@partful/instructions-domain-models';
import { useTenant } from '@providers/Tenant';
import { InfiniteData, QueryClient, useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { instructionQueryKeys } from '../../shared/api/queryKeys';
import { StepsService } from '../api/stepsService';

export function useUpdateStepNotice() {
  const queryClient = useQueryClient();
  const { accountId } = useTenant();
  const service = useMemo(() => new StepsService(), []);

  return useMutation<
    (StepNoticeModel & Partial<StepNoticeWithContentModel>) | null,
    unknown,
    {
      instructionId: string;
      versionId: string;
      segmentId: string;
      stepId: string;
      stepNoticeId: string;
      languageCode: string;
      args: UpdateStepNoticeModel;
    }
  >({
    mutationFn: ({ instructionId, versionId, segmentId, stepId, stepNoticeId, languageCode, args }) =>
      service.updateNotice(accountId, instructionId, versionId, segmentId, stepId, stepNoticeId, languageCode, args),
    onSuccess: (data, { stepId, stepNoticeId }) => updateStepNoticeCache(queryClient, data, stepId, stepNoticeId),
  });
}

function updateStepNoticeCache(
  queryClient: QueryClient,
  model: (StepNoticeModel & Partial<StepNoticeWithContentModel>) | null,
  stepId: string,
  stepNoticeId: string
) {
  queryClient.setQueryData<InfiniteData<List<StepNoticeModel & Partial<StepNoticeWithContentModel>>>>(
    [instructionQueryKeys.listStepNotices, stepId],
    (oldData) => {
      if (oldData) {
        return {
          ...oldData,
          pages: oldData.pages.map((page) => ({
            ...page,
            items: page.items.map((notice) => {
              if (notice.id === stepNoticeId) {
                return model ?? /* istanbul ignore next */ notice;
              }

              return notice;
            }),
          })),
        };
      }
    }
  );
}
